import React from 'react';
import { Box } from '../../Guidance.types';
import { Wrapper } from './Rect.style';

export type RectProps = {
  box: Box;
  children?: React.ReactNode;
};

export function Rect(props: RectProps) {
  const { box } = props;
  const { x, y, width, height } = box;

  const style: React.CSSProperties = {
    position: 'absolute',
    left: x,
    top: y,
    width: width,
    height: height,
  };

  return (
    <Wrapper style={style} className='Rect-wrapper' data-testid='Rect-wrapper'>
      {props.children}
    </Wrapper>
  );
}

export default Rect;
